import { useSeekGlobalData } from './useSeekGlobalData';

export const useSeekPayTypes = () => {
  const { processedData, setProcessedData } = useSeekGlobalData({
    key: 'payTypes',
    endpoint: '/api/v4/seek/pay_types'
  });

  return { payTypes: processedData, setPayTypes: setProcessedData };
};
